import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.register');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-register',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.register/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageRegisterComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        name: '',
        email: '',
        password: '',
        passwordConfirm: ''
    };

    public loading: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.isLoggedIn()) {
            location.replace('/dashboard');
            return;
        }

        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async register() {
        if (this.loading)
            return;

        if (!this.data.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!this.data.email) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!this.data.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (this.data.password.length < 6) {
            await this.alert("비밀번호는 6자 이상이어야 합니다.");
            return;
        }
        if (this.data.password !== this.data.passwordConfirm) {
            await this.alert("비밀번호가 일치하지 않습니다.");
            return;
        }

        this.loading = true;
        await this.service.render();

        try {
            const response: any = await wiz.call("register", {
                name: this.data.name,
                email: this.data.email,
                password: this.data.password
            });

            if (response && response.code === 200) {
                await this.alert("회원가입이 완료되었습니다. 로그인해주세요.", "success");
                location.replace("/access");
                return;
            }

            await this.alert(
                response && response.data && response.data.message
                    ? response.data.message
                    : "회원가입에 실패했습니다."
            );
        } catch (e) {
            await this.alert("회원가입 요청 중 오류가 발생했습니다.");
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PageRegisterComponent;